<app-header></app-header>
<div class="container">
  <div class="content">
    <div class="col-12">
      <h3 style="color: #004AAC">{{candidateProfile.summary}}</h3>
      <h5 class="headline">{{candidateProfile.headline}}</h5>
      <h5 *ngIf="candidateProfile.agency" class="headline">Contractor candidate from vendor {{candidateProfile.agency}}</h5>
    </div>

    <div *ngFor="let fieldGroup of candidateProfile.field_groups" >
      <div *ngIf="(fieldGroup.fields | keyvalue)?.length" class="col-md-12 title" style="padding-top: 20px"> <span (click)="hideBlock(fieldGroup.title)" style="cursor: pointer" >{{fieldGroup.title}}</span></div>
         <div style="padding-right: 2px" [attr.data-testid]="fieldGroup.title + '-fields-block'" *ngIf="!hideBlocks.includes(fieldGroup.title)">
           <div class="row fields-block" *ngFor="let field of fieldGroup.fields">
             @if (fieldGroup.title == "Skills" && (field.key == "Expert" || field.key == "Advanced" || field.key == "Intermediate" || field.key == "Novice" || field.key == "Basic" || field.key == "Other" ) ){

               <div class="col-key-3 fields-bg name" id="{{field.key.replaceAll(' ', '-') + '-key'}}"> {{field.key}}</div>
               <div class="col-value-9 fields-bg" id="{{field.key.replaceAll(' ', '-') + '-value'}}" [attr.data-testid]="field.key + '-values-section'">
                 <div class ="skills-row" *ngFor="let skill of extractUuids(field.value)" >
                   <div class="chip" > {{ skill.skillName }} &nbsp;
                     <span class="experience"> {{( skill.experience ? (" " +  (skill.experience >= 10 ? "9+" :
                       (skill.experience < 1 ? "<1" : skill.experience ) ) ) +"y" : "" )}}</span>  </div>
                 </div>
               </div>
               <div class="col-12 fields-sm" [attr.data-testid]="field.key + '-values-section'" ><span style="color: gray; font-weight: 550; margin-right: 5px">{{field.key}}:</span>
                 <div class ="skills-row" *ngFor="let skill of extractUuids(field.value)" >
                   <div class="chip" > {{ skill.skillName }} &nbsp;  <span class="experience"> {{( skill.experience ? (" " +  (skill.experience >= 10 ? "9+" :
                     (skill.experience < 1 ? "<1" : skill.experience )) ) +"y" : "" )}}</span>  </div>
                 </div>
               </div>



             } @else {
               <div class="col-key-3 fields-bg name" id="{{field.key.replaceAll(' ', '-') + '-key'}}"> {{field.key}}</div>
               <div class="col-value-9 fields-bg" id="{{field.key.replaceAll(' ', '-') + '-value'}}" [innerHTML]="formatText(field.value) | sanitizeHtml"></div>
               <div class="col-12 fields-sm"><span style="color: gray; font-weight: 550; margin-right: 5px">{{field.key}}:</span><span [innerHTML]="formatText(field.value) | sanitizeHtml"> </span></div>
             }

           </div>
         </div>
    </div>

    <div *ngIf="candidateProfile.salaryExpectationPanel && (candidateProfile.salaryExpectationPanel | json) != '{}'">
      <div class="col-md-12 title se-title" style="padding-top: 20px"> <span (click)="hideBlock('Salary Expectations')" style="cursor: pointer" >Salary Expectations</span></div>
      <div style="padding-right: 2px" *ngIf="!hideBlocks.includes('Salary Expectations')">
        <div class="row" *ngIf="(candidateProfile.salaryExpectationPanel.salaryExpectationFields | keyvalue)?.length">
          <div class="col-key-3 name">Salary Expectations</div>
            <div class="col-value-9 se-big-table">
              <div class="col-12 se-big-table-row" *ngFor="let expectation of candidateProfile.salaryExpectationPanel.salaryExpectationFields">
                <div class="col-12" style="margin-bottom: 8px">
                  <span style="color: gray">{{expectation.date | date: 'dd/MM/yyyy'}}&nbsp;</span>
                  <span style="font-weight: bold">{{expectation.value + " " + expectation.currency}}</span>
                  {{getSalaryExpectation(expectation)}}<br>
                  <span *ngIf="expectation.salaryExpectationComment" style="color: gray">SE Comment</span>
                  {{expectation.salaryExpectationComment}}
                </div>
              </div>
          </div>
        </div>
        <div style="padding-right: 2px">
          <div class="row" *ngIf="candidateProfile.salaryExpectationPanel.seComment">
            <div class="col-key-3 name">SE Comment</div>
            <div class="col-value-9">{{candidateProfile.salaryExpectationPanel.seComment}}</div>
          </div>
          <div class="row" *ngIf="candidateProfile.salaryExpectationPanel.currentSalary">
            <div class="col-key-3 name">Current Salary</div>
            <div class="col-value-9">{{ candidateProfile.salaryExpectationPanel.currentSalary }}</div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="(candidateProfile.parallelProcessingStatuses | keyvalue)?.length">
      <div class="col-md-12 title" style="padding-top: 20px"> <span (click)="hideBlock('Parallel Processing Status')" style="cursor: pointer" >Parallel Processing Status</span></div>
        <div class="pps-big-table" style="padding: 0 11px" *ngIf="!hideBlocks.includes('Parallel Processing Status')">
          <div class="row" style="border-bottom: 1px #cccdd7 solid; color: gray; font-weight: 550; padding: 4px 0 8px 0" >
            <div class="col-3" style="padding-left: 0">Business unit</div>
            <div class="col-3">Hiring Manager</div>
            <div class="col-3">Interview type</div>
            <div class="col-3">Feedback status</div>
        </div>
        <div class="pps-big-table-row" *ngFor="let parallelProcessing of candidateProfile.parallelProcessingStatuses">
          <div class="row pps" style="border-bottom: 1px #cccdd7 solid; padding: 5px 0">
            <div class="col-3" style="padding-left: 0">{{ parallelProcessing.businessUnit}}</div>
            <div class="col-3">{{ parallelProcessing.hiringManager}}</div>
            <div class="col-3">{{ parallelProcessing.interviewType}}</div>
            <div class="col-3">{{ parallelProcessing.feedbackStatus}}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="l-s-cv" *ngIf="(candidateProfile.lastSentCVList | keyvalue)?.length">
      <div class="col-md-12 title" style="padding-top: 20px"> <span (click)="hideBlock('Last sent CV')" style="cursor: pointer" >Last sent CV</span></div>
        <div *ngIf="!hideBlocks.includes('Last sent CV')">
        <div style="padding-right: 2px" *ngFor="let cv of candidateProfile.lastSentCVList">
          <div class="row">
            <div class="col-cv"><a class="link" style="text-decoration: underline; cursor: pointer" (click)="downloadFile(cv.attachmentKey, cv.attachmentHash, cv.fileName)">{{cv.fileName}}</a></div>
            <div class="col-2">{{cv.fileSize}}</div>
            <div class="col-3">{{cv.createdDateFormatted | date:'dd/MM/yyyy'}}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="r-a-r" *ngIf="(candidateProfile.messageDtos | keyvalue)?.length">
      <div class="col-md-12 title" style="padding-top: 20px"> <span (click)="hideBlock('Recruiter and Researcher')" style="cursor: pointer" >Recruiter and Researcher</span></div>
      <div *ngIf="!hideBlocks.includes('Recruiter and Researcher')">
        <div style="padding-right: 2px" *ngFor="let message of candidateProfile.messageDtos">
          <div class="row">
            <div id="{{message.recruiter.position.replaceAll(' ', '-') + '-key'}}" class="col-position name">{{message.recruiter.position}}</div>
            <div id="{{message.recruiter.position.replaceAll(' ', '-') + '-value'}}" class="col-name"><a href="mailto:{{message.recruiter.email}}?subject={{message.emailTemplate.subject}}&body=Candidate Profile: {{message.candidateProfile.candidateProfileLink}}">{{message.recruiter.displayName}}</a> </div>
          </div>
        </div>
      </div>
    </div>


    <div class="ti-big">
      <div class="col-md-12 title" style="padding-top: 20px"> <span (click)="hideBlock('Previous Technical Interviews (for the last 6 months)')" style="cursor: pointer" >Previous Technical Interviews (for the last 6 months)</span></div>
      <div style="padding: 0 11px" class="ti-big-table" *ngIf="!hideBlocks.includes('Previous Technical Interviews (for the last 6 months)')">
        @if ((candidateProfile.previousTechnicalInterviews | keyvalue)?.length) {
          <div class="row" style="border-bottom: 1px #cccdd7 solid; color: gray; font-weight: 550; padding: 4px 0 8px 0" >
            <div class="col-2" style="padding-left: 0">Date</div>
            <div class="col-4">Vacancy</div>
            <div class="col-2">Candidate Level</div>
            <div class="col-2">Feedback status</div>
            <div class="col-1">Attachments</div>
          </div>
          <div class="ti-big-table-row" *ngFor="let technicalInterview of candidateProfile.previousTechnicalInterviews; let m = index">
            <div class="row pps" style="border-bottom: 1px #cccdd7 solid; padding: 5px 0">
              <div class="col-2" style="padding-left: 0">{{ technicalInterview.date | date:'dd/MM/yyyy'}}</div>
              <div class="col-4">{{ technicalInterview.vacancy}}</div>
              <div class="col-2">{{ technicalInterview.feedbackStatus }}</div>
              <div class="col-2">{{ technicalInterview.candidateLevel }}</div>
              <div class="col-1">
                <div class="row" *ngFor="let attachment of technicalInterview.attachments">
                  <div class="col-12">
                    <em matTooltip="{{attachment.name}}" matTooltipPosition="right" (click)="downloadFile(attachment.key, attachment.hash, attachment.name)" style="color: #004AAC; cursor: pointer;  font-size: 15px" class="bi bi-file-earmark-break-fill"></em>
                  </div>
                </div>
              </div>
            </div>

            <div *ngIf="technicalInterview.feedbackMessageDtos.length" class="row" style="border-bottom: 1px #cccdd7 solid; padding: 5px 0">
              <div class="col-12 event-messages-title" style="color: gray; font-weight: 550; padding-left: 0"><span (click)="showDetails(technicalInterview)" style="cursor: pointer">Messages ({{technicalInterview.feedbackMessageDtos.length}})</span></div>
              <div style="padding-top: 5px" class="event-messages-block" *ngIf="technicalInterview.showDetails">
                <div class="row" *ngFor="let feedback of technicalInterview.feedbackMessageDtos; let i = index">
                  <div id="tib-{{m}}-{{i}}" *ngIf="!feedback.showDetails" class="col-12"
                       style="overflow: hidden; white-space: nowrap; text-overflow: ellipsis; padding-bottom: 5px; padding-left: 1px">
                    <em (click)="isTextOverflow('tib-' + m + '-' + i) ? feedbackShowDetails(feedback): ''" style="background-color: #F6F7F9; color: black; cursor: pointer"
                       class="bi bi-caret-right-square"></em> <span (click)="isTextOverflow('tib-' + m + '-' + i) ? feedbackShowDetails(feedback): ''" style="cursor: pointer"> {{ feedback.receivedDate | date: 'dd/MM/yyyy HH:mm' }} </span> <a
                    href="mailto:{{feedback.sender.email}}">{{ feedback.sender.name }}</a> <span (click)="isTextOverflow('tib-' + m + '-' + i) ? feedbackShowDetails(feedback): ''" style="cursor: pointer"> {{ feedback.message }}</span>
                  </div>
                  <div *ngIf="feedback.showDetails" class="col-12 expanded" style="padding-bottom: 5px; padding-left: 1px; white-space: break-spaces">
                    <em (click)="feedbackShowDetails(feedback)" style="background-color: #F6F7F9; color: black; cursor: pointer"
                       class="bi bi-caret-down-square"></em> {{ feedback.receivedDate | date: 'dd/MM/yyyy HH:mm' }} <span *ngIf="feedback.sender.name"><a *ngIf="feedback.sender.name"
                                                                                                                                                         href="mailto:{{feedback.sender.email}}">{{ feedback.sender.name }}</a>&nbsp;</span><span
                    [innerHTML]="feedback.message | sanitizeHtml"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        } @else {
         <app-absent-block [blockName]="'technical interviews'"></app-absent-block>
        }
      </div>
    </div>

    <div class="ti-small">
      <div class="col-md-12 title" style="padding-top: 20px"> <span (click)="hideBlock('Previous Technical Interviews (for the last 6 months)')" style="cursor: pointer" >Previous Technical Interviews (for the last 6 months)</span></div>
      <div *ngIf="!hideBlocks.includes('Previous Technical Interviews (for the last 6 months)')">
        @if ((candidateProfile.previousTechnicalInterviews | keyvalue)?.length) {
          <div style="padding: 0 11px" *ngFor="let technicalInterview of candidateProfile.previousTechnicalInterviews; let m = index">
            <div class="row pps" style="border-bottom: 1px #cccdd7 solid; padding: 5px 0">
              <div class="col-12" style="padding: 0"><span style="color: gray">Date:</span> {{ technicalInterview.date | date:'dd/MM/yyyy'}}</div>
              <div class="col-12" style="padding: 0"><span style="color: gray">Vacancy:</span> {{technicalInterview.vacancy}}</div>
              <div class="col-12" style="padding: 0"><span style="color: gray">Candidate Level:</span> {{ technicalInterview.feedbackStatus }}</div>
              <div class="col-12" style="padding: 0"><span style="color: gray">Feedback status:</span> {{ technicalInterview.candidateLevel }}</div>
              <div class="col-12" style="padding: 0"><span style="color: gray">Attachments:</span>
                <div class="col-12" *ngFor="let attachment of technicalInterview.attachments">
                   {{attachment.name}} <em (click)="downloadFile(attachment.key, attachment.hash, attachment.name)" style="color: #004AAC; font-size: 25px" class="bi bi-file-earmark-break-fill"></em>
                </div>
              </div>
            </div>
            <div *ngIf="technicalInterview.feedbackMessageDtos.length" class="row" style="border-bottom: 1px #cccdd7 solid; padding: 5px 0">
              <div class="col-12" style="color: gray; font-weight: 550; padding: 0"><span (click)="showDetails(technicalInterview)" style="cursor: pointer">Messages ({{technicalInterview.feedbackMessageDtos.length}})</span></div>
              <div style="padding-top: 5px" *ngIf="technicalInterview.showDetails">
                <div class="row" *ngFor="let feedback of technicalInterview.feedbackMessageDtos; let i = index">
                  <div id="tis-{{m}}-{{i}}" *ngIf="!feedback.showDetails" class="col-12"
                       style="overflow: hidden; white-space: nowrap; text-overflow: ellipsis; padding:0 0 5px 1px">
                    <em (click)="isTextOverflow('tis-' + m + '-' + i) ? feedbackShowDetails(feedback): ''" style="background-color: #F6F7F9; color: black; cursor: pointer"
                       class="bi bi-caret-right-square"></em> <span (click)="isTextOverflow('tis-' + m + '-' + i) ? feedbackShowDetails(feedback): ''" style="cursor: pointer"> {{ feedback.receivedDate | date: 'dd/MM/yyyy HH:mm' }} </span> <a
                    href="mailto:{{feedback.sender.email}}">{{ feedback.sender.name }}</a><span (click)="isTextOverflow('tis-' + m + '-' + i) ? feedbackShowDetails(feedback): ''" style="cursor: pointer"> {{ feedback.message }}</span>
                  </div>
                  <div *ngIf="feedback.showDetails" class="col-12" style="padding:0 0 5px 1px; white-space: break-spaces">
                    <em (click)="feedbackShowDetails(feedback)" style="background-color: #F6F7F9; color: black; cursor: pointer"
                       class="bi bi-caret-down-square"></em> {{ feedback.receivedDate | date: 'dd/MM/yyyy HH:mm' }} <span *ngIf="feedback.sender.name"><a *ngIf="feedback.sender.name"
                    href="mailto:{{feedback.sender.email}}">{{ feedback.sender.name }}</a>&nbsp;</span><span
                    [innerHTML]="feedback.message | sanitizeHtml"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        } @else {
          <div style="padding: 0 11px">
            <app-absent-block [blockName]="'technical interviews'"></app-absent-block>
          </div>
        }
      </div>
    </div>

    <div class="ti-big">
      <div class="col-md-12 title" style="padding-top: 20px"> <span (click)="hideBlock('Previous assessments (for the last 6 months)')" style="cursor: pointer" >Previous assessments (for the last 6 months)</span></div>
      <div style="padding: 0 11px" class="pa-big-table" *ngIf="!hideBlocks.includes('Previous assessments (for the last 6 months)')">
        @if ((candidateProfile.coderbyteInterviews | keyvalue)?.length) {
          <div class="row" style="border-bottom: 1px #cccdd7 solid; color: gray; font-weight: 550; padding: 4px 0 8px 0" >
            <div class="col-2" style="padding-left: 0">Date</div>
            <div class="col-4">Vacancy</div>
            <div class="col-2">Candidate Level</div>
            <div class="col-2">Feedback status</div>
            <div class="col-1">Attachments</div>
          </div>
          <div class="pa-big-table-row" *ngFor="let technicalInterview of candidateProfile.coderbyteInterviews; let m = index">
            <div class="row pps" style="border-bottom: 1px #cccdd7 solid; padding: 5px 0">
              <div class="col-2" style="padding-left: 0">{{ technicalInterview.date | date:'dd/MM/yyyy'}}</div>
              <div class="col-4">{{ technicalInterview.vacancy}}</div>
              <div class="col-2">{{ technicalInterview.feedbackStatus }}</div>
              <div class="col-2">{{ technicalInterview.candidateLevel }}</div>
              <div class="col-1">
                <div class="row" *ngFor="let attachment of technicalInterview.attachments">
                  <div class="col-12">
                    <em matTooltip="{{attachment.name}}" matTooltipPosition="right" (click)="downloadFile(attachment.key, attachment.hash, attachment.name)" style="color: #004AAC; cursor: pointer;  font-size: 15px" class="bi bi-file-earmark-break-fill"></em>
                  </div>
                </div>
              </div>
            </div>

            <div *ngIf="technicalInterview.feedbackMessageDtos.length" class="row" style="border-bottom: 1px #cccdd7 solid; padding: 5px 0">
              <div class="col-12 event-messages-title" style="color: gray; font-weight: 550; padding-left: 0"><span (click)="showDetails(technicalInterview)" style="cursor: pointer">Messages ({{technicalInterview.feedbackMessageDtos.length}})</span></div>
              <div class="event-messages-block" style="padding-top: 5px" *ngIf="technicalInterview.showDetails">
                <div class="row" *ngFor="let feedback of technicalInterview.feedbackMessageDtos; let i = index">
                  <div id="cbb-{{m}}-{{i}}" *ngIf="!feedback.showDetails" class="col-12"
                       style="overflow: hidden; white-space: nowrap; text-overflow: ellipsis; padding-bottom: 5px; padding-left: 1px">
                    <em (click)="isTextOverflow('cbb-' + m + '-' + i) ? feedbackShowDetails(feedback): ''" style="background-color: #F6F7F9; color: black; cursor: pointer"
                       class="bi bi-caret-right-square"></em> <span (click)="isTextOverflow('cbb-' + m + '-' + i) ? feedbackShowDetails(feedback): ''" style="cursor: pointer"> {{ feedback.receivedDate | date: 'dd/MM/yyyy HH:mm' }} </span> <a
                    href="mailto:{{feedback.sender.email}}">{{ feedback.sender.name }}</a> <span (click)="isTextOverflow('cbb-' + m + '-' + i) ? feedbackShowDetails(feedback): ''" style="cursor: pointer"> {{ feedback.message }}</span>
                  </div>
                  <div *ngIf="feedback.showDetails" class="col-12 expanded" style="padding-bottom: 5px; padding-left: 1px; white-space: break-spaces">
                    <em (click)="feedbackShowDetails(feedback)" style="background-color: #F6F7F9; color: black; cursor: pointer"
                       class="bi bi-caret-down-square"></em> {{ feedback.receivedDate | date: 'dd/MM/yyyy HH:mm' }} <span *ngIf="feedback.sender.name"><a *ngIf="feedback.sender.name"
                    href="mailto:{{feedback.sender.email}}">{{ feedback.sender.name }}</a>&nbsp;</span><span
                    [innerHTML]="feedback.message | sanitizeHtml"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        } @else {
          <app-absent-block [blockName]="'assessments'"></app-absent-block>
        }
      </div>
    </div>

    <div class="ti-small">
      <div class="col-md-12 title" style="padding-top: 20px"> <span (click)="hideBlock('Previous assessments (for the last 6 months)')" style="cursor: pointer" >Previous assessments (for the last 6 months)</span></div>
      <div *ngIf="!hideBlocks.includes('Previous assessments (for the last 6 months)')">
        @if ((candidateProfile.coderbyteInterviews | keyvalue)?.length) {
          <div style="padding: 0 11px" *ngFor="let technicalInterview of candidateProfile.coderbyteInterviews; let m = index">
            <div class="row pps" style="border-bottom: 1px #cccdd7 solid; padding: 5px 0">
              <div class="col-12" style="padding: 0"><span style="color: gray">Date:</span> {{ technicalInterview.date | date:'dd/MM/yyyy'}}</div>
              <div class="col-12" style="padding: 0"><span style="color: gray">Vacancy:</span> {{technicalInterview.vacancy}}</div>
              <div class="col-12" style="padding: 0"><span style="color: gray">Candidate Level:</span> {{ technicalInterview.feedbackStatus }}</div>
              <div class="col-12" style="padding: 0"><span style="color: gray">Feedback status:</span> {{ technicalInterview.candidateLevel }}</div>
              <div class="col-12" style="padding: 0"><span style="color: gray">Attachments:</span>
                <div class="col-12" *ngFor="let attachment of technicalInterview.attachments">
                  {{attachment.name}} <em (click)="downloadFile(attachment.key, attachment.hash, attachment.name)" style="color: #004AAC; font-size: 25px" class="bi bi-file-earmark-break-fill"></em>
                </div>
              </div>
            </div>
            <div *ngIf="technicalInterview.feedbackMessageDtos.length" class="row" style="border-bottom: 1px #cccdd7 solid; padding: 5px 0">
              <div class="col-12" style="color: gray; font-weight: 550; padding: 0"><span (click)="showDetails(technicalInterview)" style="cursor: pointer">Messages ({{technicalInterview.feedbackMessageDtos.length}})</span></div>
              <div style="padding-top: 5px" *ngIf="technicalInterview.showDetails">
                <div class="row" *ngFor="let feedback of technicalInterview.feedbackMessageDtos; let i = index">
                  <div id="cbm-{{m}}-{{i}}" *ngIf="!feedback.showDetails" class="col-12"
                       style="overflow: hidden; white-space: nowrap; text-overflow: ellipsis; padding:0 0 5px 1px">
                    <em (click)="isTextOverflow('cbm-' + m + '-' + i) ? feedbackShowDetails(feedback): ''" style="background-color: #F6F7F9; color: black; cursor: pointer"
                       class="bi bi-caret-right-square"></em> <span (click)="isTextOverflow('cbm-' + m + '-' + i) ? feedbackShowDetails(feedback): ''" style="cursor: pointer"> {{ feedback.receivedDate | date: 'dd/MM/yyyy HH:mm' }} </span> <a
                    href="mailto:{{feedback.sender.email}}">{{ feedback.sender.name }}</a><span (click)="isTextOverflow('cbm-' + m + '-' + i) ? feedbackShowDetails(feedback): ''" style="cursor: pointer"> {{ feedback.message }}</span>
                  </div>
                  <div *ngIf="feedback.showDetails" class="col-12" style="padding:0 0 5px 1px;  white-space: break-spaces">
                    <em (click)="feedbackShowDetails(feedback)" style="background-color: #F6F7F9; color: black; cursor: pointer"
                       class="bi bi-caret-down-square"></em> {{ feedback.receivedDate | date: 'dd/MM/yyyy HH:mm' }} <span *ngIf="feedback.sender.name"><a
                    href="mailto:{{feedback.sender.email}}">{{ feedback.sender.name }}</a>&nbsp;</span><span
                    [innerHTML]="feedback.message | sanitizeHtml"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        } @else {
          <div style="padding: 0 11px">
            <app-absent-block [blockName]="'assessments'"></app-absent-block>
          </div>
        }
      </div>
    </div>

    <div *ngIf="(candidateProfile.luxoft_experiences | keyvalue)?.length">
      <div class="col-md-12 title" style="padding-top: 20px"> <span (click)="hideBlock('Previous internal positions')" style="cursor: pointer" >Previous internal positions</span></div>
      <div class="pip-big-table" style="padding: 0 11px" *ngIf="!hideBlocks.includes('Previous internal positions')">
        <div class="row" style="border-bottom: 1px #cccdd7 solid; color: gray; font-weight: 550; padding: 4px 0 8px 0" >
          <div style="padding-left: 0" class="pip-col-3">Date</div>
          <div class="pip-value-9">Event</div>
        </div>
        <div class="pip-big-table-row" *ngFor="let experience of getSortedExperience()">
          <div class="row pps" style="border-bottom: 1px #cccdd7 solid; padding: 5px 0">
            <div class="pip-col-3" style="color: black; padding-left: 0">{{experience[0] | date: 'dd/MM/yyyy'}}</div>
            <div class="pip-value-9"><span style="font-weight: bold">{{experience[1].eventType}}</span> {{getExperienceDetails(experience[1])}}</div>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>
<app-footer></app-footer>
